import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "proofreading-actions-container"
}
const _hoisted_2 = { class: "panel-title" }
const _hoisted_3 = { class: "proofreading-actions-container" }
const _hoisted_4 = { class: "panel-title" }
const _hoisted_5 = { class: "configuration-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProofreadingActions = _resolveComponent("ProofreadingActions")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_PostProofreadingInstructions = _resolveComponent("PostProofreadingInstructions")!
  const _component_TranslationConfig = _resolveComponent("TranslationConfig")!
  const _component_SegmentListPreview = _resolveComponent("SegmentListPreview")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.documentData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_el_card, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('proofreading.panelTitle')), 1),
              _createVNode(_component_ProofreadingActions, { document: _ctx.documentData }, null, 8, ["document"])
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_el_card, null, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('proofreadingInstructions.postProofreadingInstructionsTitle')), 1),
          _createVNode(_component_PostProofreadingInstructions)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_TranslationConfig, {
        modelValue: _ctx.translationConfig,
        "view-mode": true,
        documentType: _ctx.documentType,
        pageNamePrefix: _ctx.$t('archive.configurationPrefix')
      }, null, 8, ["modelValue", "documentType", "pageNamePrefix"])
    ]),
    _createVNode(_component_SegmentListPreview, { "scroll-on-load": false })
  ]))
}